import { render, staticRenderFns } from "./EventCoverUpload.vue?vue&type=template&id=1b2ff949&scoped=true"
import script from "./EventCoverUpload.vue?vue&type=script&lang=js"
export * from "./EventCoverUpload.vue?vue&type=script&lang=js"
import style0 from "./EventCoverUpload.vue?vue&type=style&index=0&id=1b2ff949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ff949",
  null
  
)

export default component.exports